import { useState } from 'react';
import { ExpandMore } from '@mui/icons-material';
import { Accordion, AccordionDetails, AccordionSummary, Stack, Typography } from '@mui/material';

export interface IPositionAccordionsItem {
  summary: string;
  details: JSX.Element;
}
interface IPositionAccordionsProps {
  items: IPositionAccordionsItem[];
}
const style = { border: 'none', boxShadow: 'none' };

const PositionAccoridions = ({ items }: IPositionAccordionsProps) => {
  const [expanded, setExpanded] = useState<string | false>(false);

  const handleChange = (panel: string) => (event: React.SyntheticEvent, newExpanded: boolean) => {
    setExpanded(newExpanded ? panel : false);
  };

  return (
    <Stack width="100%" spacing={3}>
      {items.map((item: IPositionAccordionsItem, index: number) => (
        <Accordion
          key={index}
          expanded={expanded === `accordion${index}`}
          onChange={handleChange(`accordion${index}`)}
          sx={{
            m: 0,
            ...style,
            '&.MuiAccordion-root::before': {
              content: 'unset',
            },
          }}
        >
          <AccordionSummary
            expandIcon={<ExpandMore sx={{ color: expanded === `accordion0` ? '#fff' : '#000' }} />}
            aria-controls="panel1d-content"
            id="panel1d-header"
            sx={{
              backgroundColor: 'primaryDark.200',
              '&.Mui-expanded': {
                backgroundColor: 'primaryLight.500',
                color: '#fff',
              },
              expandIcon: {
                color: '#fff',
                backgroundColor: '#fff',
              },
              borderRadius: '0.3rem',
              ...style,
            }}
          >
            <Typography sx={{ typography: { xs: 'publicBody4Light', sm: 'publicBody3Light' } }}>
              {item.summary}
            </Typography>
          </AccordionSummary>

          <AccordionDetails
            sx={{
              backgroundColor: 'transparent',
              mt: 1,
              pb: 1,
              ...style,
            }}
          >
            <Stack>{item.details}</Stack>
          </AccordionDetails>
        </Accordion>
      ))}
    </Stack>
  );
};
export default PositionAccoridions;
